import { render, staticRenderFns } from "./SecondMenuLinkContent.vue?vue&type=template&id=12fd4104&scoped=true&"
import script from "./SecondMenuLinkContent.vue?vue&type=script&lang=js&"
export * from "./SecondMenuLinkContent.vue?vue&type=script&lang=js&"
import style0 from "./SecondMenuLinkContent.vue?vue&type=style&index=0&id=12fd4104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd4104",
  null
  
)

export default component.exports